import React from "react";

export const paisDeLilacPublishedAt = (
  <span className="white">
    <i>El país de Lilac</i> (1938) y <i>Retorno a Lilac</i> (1987)
  </span>
);
